import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "dt-mainCard__content-block" }
const _hoisted_2 = {
  key: 0,
  class: "dt-mainCard__content-block-title"
}
const _hoisted_3 = { class: "block-textMin" }
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.element.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString($props.element.title), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.element.items, (content) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          (content['@type'] === 'content-editor')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                innerHTML: $options.render(content.value.content)
              }, null, 8 /* PROPS */, _hoisted_4))
            : _createCommentVNode("v-if", true)
        ], 64 /* STABLE_FRAGMENT */))
      }), 256 /* UNKEYED_FRAGMENT */))
    ])
  ]))
}